import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BRAND, FONT_DISPLAY, FONT_SANS, HERO_GRADIENT } from '../styles/brand';

/**
 * Enveloppe standard pour les pages internes (hors accueil).
 */
const PageLayout = ({
  title,
  subtitle,
  tagline,
  backTo,
  backLabel,
  children,
  hero,
  compactHero = false,
  className = ''
}) => {
  const heroPadding = compactHero ? '2.75rem 1rem 2.25rem' : '3.5rem 1rem 3rem';

  return (
    <div className={`app-page ${className}`.trim()} style={{ fontFamily: FONT_SANS }}>
      {hero ?? (
        (title || subtitle) && (
          <header
            className="app-page-hero"
            style={{
              background: HERO_GRADIENT,
              color: '#fff',
              padding: heroPadding,
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            <div
              aria-hidden
              style={{
                position: 'absolute',
                inset: 0,
                opacity: 0.35,
                background:
                  'radial-gradient(circle at 15% 20%, rgba(255, 255, 255, 0.22), transparent 45%)'
              }}
            />
            <div
              style={{
                position: 'relative',
                zIndex: 1,
                width: 'min(1120px, calc(100% - 2rem))',
                margin: '0 auto'
              }}
            >
              {backTo && (
                <Link
                  to={backTo}
                  className="app-back-link"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.35rem',
                    color: 'rgba(255,255,255,0.9)',
                    textDecoration: 'none',
                    fontWeight: 600,
                    fontSize: '0.9rem',
                    marginBottom: '1rem'
                  }}
                >
                  <ArrowLeft size={18} aria-hidden />
                  {backLabel || 'Retour'}
                </Link>
              )}
              {tagline && (
                <p
                  style={{
                    margin: '0 0 0.65rem',
                    fontSize: '0.82rem',
                    fontWeight: 700,
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                    color: BRAND.goldSoft
                  }}
                >
                  {tagline}
                </p>
              )}
              {title && (
                <h1
                  style={{
                    margin: '0 0 0.5rem',
                    fontFamily: FONT_DISPLAY,
                    fontSize: 'clamp(1.85rem, 5vw, 2.75rem)',
                    fontWeight: 560,
                    letterSpacing: '-0.02em',
                    lineHeight: 1.05
                  }}
                >
                  {title}
                </h1>
              )}
              {subtitle && (
                <p
                  style={{
                    margin: 0,
                    maxWidth: '40rem',
                    fontSize: '1.05rem',
                    lineHeight: 1.55,
                    color: 'rgba(255,255,255,0.88)'
                  }}
                >
                  {subtitle}
                </p>
              )}
            </div>
          </header>
        )
      )}
      <div className="app-page-body">{children}</div>
    </div>
  );
};

export default PageLayout;
